<topo-app-header #header />

<div id="app-content">
  <topo-system-notifications
    [isSideNavVisible]="isSideNavEnabled() && sideNav()?.show()"
    [isSideNavExpanded]="sideNav()?.isExpanded() && sideNav()?.show()" />

  @if (isSideNavEnabled()) {
    <topo-app-side-nav #side_nav [isHeaderVisible]="header?.show()" />
  }
  <router-outlet />
</div>

<topo-version-check />
